import React, { useState, useEffect } from "react";
import "./index.less";
import intl from "react-intl-universal";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
import Question from "../components/question.jsx";
const locales = {
    en_US,
    zh_CN,
};
//题库详情页
function PreviewQuestion(props) {
    const [dataInfo, setDataInfo] = useState([]); //当前操作数据信息

    useEffect(() => {
        intl
            .init({
                currentLocale: localStorage.getItem("language_type") || "zh_CN",
                locales,
            })
            .then(() => { });
        if (dataInfo.length === 0) {
            const info = localStorage.getItem('previewQuestionInfo');
            setDataInfo(JSON.parse(info));
        }
    }, []);


    const renderPreviewQuestions = () => {
        return dataInfo?.map((question, i) => {
            return <Question
                key={`question-${i}`}
                canEdit={false}
                index={i}
                data={question}
                status={'preview'}
                hideDeleteBtn />
        })
    }

    return (
        <div className="createQuestionWrapper">
            <div className="headerWrap">
                <div className="alignCenter fl title">
                    <b>{intl.get("53bbcd25-b0d9-2d4c-8fd5-1b752e04a5c6")}</b>
                </div>
                <div className="alignEnd fr">
                    <span className="quitPreview fs16" onClick={() => window.close()}>
                        {intl.get("b380f62d-7e47-20b5-9e58-18a0ac84c855")}
                    </span>
                </div>
            </div>
            <div className="questionListPreviewWrap">
                <div className="questionContent">
                    {renderPreviewQuestions()}
                </div>
            </div>
        </div>
    );
}
export default PreviewQuestion;